export default {
  mobileMinTabMax: '(min-width: 320px) and (max-width: 768px)',
  mobileMinMobMax: '(min-width: 280px) and (max-width: 425px)',
};
